<template>
  <div class="checkbox colorscale-checkbox">
    <label>
      <input type="checkbox" :checked="checked" v-on:change="toggleScale"/>Grayscale
    </label>
  </div>
</template>

<script>
export default {
  name: 'scale-toggle',
  props: ['grayscale', 'toggleScale'],
  computed: {
    checked() {
      return this.grayscale;
    },
  },
};
</script>

<style lang="less">
  .map-controls-wrapper {
    .colorscale-checkbox {
      margin-top: 0;
      @media (max-width: 700px) {
        height: 20px; 
      }
    }
  }
  
  .colorscale-checkbox {
    align-self: flex-end;
    padding-left: 10px;
    margin-bottom: 0;
    @media (max-width: 700px) {
      padding-left: 0;
      order: -1;
      align-self: flex-start;
      &.checkbox {
        margin-top: 0;
      }
    } 
  }
</style>



// WEBPACK FOOTER //
// ScaleToggle.vue?614815ba